import { render, staticRenderFns } from "./son.vue?vue&type=template&id=218088d0&"
import script from "./son.vue?vue&type=script&lang=js&"
export * from "./son.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports